export default __webpack_public_path__ + "img/ebe0c31523c86359b6e4321aff9a09ae.svg";